import { useGetIsDarkMode } from 'src/custom-hooks';

export const FailedToGetData = () => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <div className={`${isDarkMode ? 'text-white' : ''} text-center`} style={{ marginTop: '80px' }}>
            No se pudo recuperar la información de esta página
        </div>
    );
}
